import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "device-desktop-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinejoin: "round", transform: "translate(2 2.5)" },
        React.createElement("rect", { width: 13, height: 9, rx: 1 }),
        React.createElement("path", { d: "M4.25 9h4.5l-.148.443a2 2 0 0 0 .361 1.913L9.5 12h-6l.537-.644a2 2 0 0 0 .36-1.913L4.25 9Z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
